import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {StatisticState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: StatisticState = {
    smsStatisticDetail: null,
    smsStatisticDetailIncoming: [],
    smsStatisticGroup: null,
    smsStatisticGroupIncoming: undefined,
    smsGroupings: {
        smsGroup: [
            'hour',
            'day',
            'week',
            'month',
        ],
        smsGroupOptionally: [
            'broker_account_login',
            'operator',
            'originator',
            'country',
            'message_type',
            'bulk_id',
            'template_id',
        ],
    },
};


export const smsStatistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
